import angular from "angular";

import OrganisationOwnerNotificationsModuleRouting from "./organisation-owner-notifications.module.routing";

export default angular
  .module("vt-organisation-owner-notifications", [])
  .config(OrganisationOwnerNotificationsModuleRouting);
